<template>
  <div class="container fluid pt-1 dmbs-content" >
  <!-- <pre>
    -- {{ idRecinto }} kk {{ eventosPagina }} 
  </pre>   -->
    <h2 v-if="eventosPagina"  class="page-header">{{eventosPagina.recinto.Nombre}}</h2>   
    <div v-if="eventosPagina"  :key="eventosPagina.recinto.idRecinto" class="jumbotron no_space"  v-scroll="scroll">
      <div class="container infinito">
        <hr>
        <div 
         v-for="(item, v) in eventosScroll"
         :key="v"
         class="col-md-4 col-sm-6 col-xs-12">

          <router-link
          v-if="item"
            :to="`/${$i18n.locale}/detalle/${item.cmsID}/${item.Recinto[0].Id}${!queryRuta?'':queryRuta}`"
            class="vacio"
          >
              <v-img
                v-if="miImagen(item)"
                class="imagen-ficha elevation-5"
                :src="miImagen(item)"
                :aspect-ratio="ratios[defaultImageSize]"
              >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate :color="colorDestacado"></v-progress-circular>
                  </v-layout>
              </v-img>     
   

          <div class="padding12">
            <p><b>{{item.Nombre}}</b></p>
            <p><i class="fa fa-calendar"></i> {{getFecha(item)}}<br></p>
            <p class="locate"><i class="fa fa-map-marker"></i><i>{{item.Recinto[0].Nombre}}</i><br>
            </p>
            <span v-if="item.MinPrecioBase" class="pvp">Desde: {{ item.MinPrecioBase | formatNumber}}</span>
          </div>
          <a
            class="btn  btn-comprar"
            role="button"
          >
            <i class="fa fa-shopping-cart"></i>&nbsp;{{$t('Comprar')}}</a>
          <a
            class="btn  btn-info"
            role="button"
          >
            <i class="fa fa-info-circle"></i>
          </a>
          </router-link>
          <br><br>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { globales } from "../../components/comunes";
import buscadorEventos from "../../components/Buscador";

export default {
  mixins: [globales],
  props: ["idRecinto"],
  mounted() {
    // this.$store.dispatch("getRecintos");
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.cargarEventos();
  },
  components: {
    buscadorEventos,
  },
  watch: {
    $route(to, form) {
      // this.$store.dispatch("getRecintos");
      this.cargarEventos();
      this.tipoTransicion = "fade";
    },
    recintosJanto() {
      this.cargarEventos();
    },
  },
  data() {
    return {
      inicioScroll: 0,
      intervaloScroll: 24,
      finScroll: 24,
      scrolling: false,
      totalEventos: [],
      findePagina: false,
    };
  },
  computed: {
    queryRuta() {
      let parametros = "";

      const query = this.$route.query;
      if (query) {
        parametros = "/?";
        Object.keys(query).forEach(
          clave => (parametros += `&${clave}=${query[clave]}`)
        );
      }

      return parametros;
    },
    eventosPagina() {
      const idRecinto = this.idRecinto;

      const RecintoIdJanto = idRecinto.split("@")[0];

      return (
        this.$store.state.recintosJanto[RecintoIdJanto] ||
        this.$store.state.recintosJanto[idRecinto]
      );
    },
    eventosScroll: {
      get() {
        return this.$store.state.eventosScroll;
      },
      set(valor) {
        this.$store.commit("setEventosScroll", valor);
      },
    },
    recintosJanto() {
      return this.$store.state.recintosJanto;
    },
  },
  methods: {
    scroll() {
      if (this.eventosScroll.length >= this.totalEventos.length) {
        // console.log('ya estan todos', this.findePagina)
        this.findePagina = true;
      }
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;

      // console.log('v-scrooll', bottomOfWindow, this.findePagina)
      if (bottomOfWindow && !this.findePagina) {
        const inicio = this.eventosScroll.length;
        const fin = inicio + this.intervaloScroll;

        for (let o = inicio; o < fin; o++) {
          const element = this.totalEventos[o];
          // console.log(element.cms.titulo, 'evento', o, '/',this.totalEventos.length)
          this.eventosScroll.push(element);
        }
      }
      //  console.log('scriolll', window.innerHeight, document.documentElement.scrollTop, document.documentElement.offsetHeight )
    },
    vigencia(evento) {
      const ahora = this.Hoy.ahora;
      const vigente = evento < ahora;
      // console.log(evento.Nombre, 'vigencia', vigente)

      return vigente;
    },
    cargarEventos() {
      // this.$store.dispatch('getRecintos')
      var eventos = [];
      const recinto = this.idRecinto;
      const misRecintos = this.recintosJanto
        ? Object.values(this.recintosJanto)
        : [];
      const filtro = misRecintos.find(
        e => e.recinto && e.recinto.idRecinto == recinto
      );
      this.totalEventos = filtro ? filtro.eventos : [];
      const ahora = this.Hoy.ahora;
      // console.log('cargar EVENOTS', filtro, this.totalEventos)

      const fin = this.finScroll;
      const inicio = this.inicioScroll;
      for (let o = inicio; o < fin; o++) {
        const element = this.totalEventos[o];
        eventos.push(element);
      }

      this.eventosScroll = this.totalEventos.sort(function(a, b) {
        var nameA = a.FSesionMin.replace(/[^\w\s]/gi, "")
          .toUpperCase()
          .trim(); // ignore upper and lowercase
        var nameB = b.FSesionMin.replace(/[^\w\s]/gi, "")
          .toUpperCase()
          .trim(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    },
  },
};
</script>
